import { combineReducers } from "redux";

import countriesReducer from "../features/countries/countriesSlice";
import indiaStatsReducer from "../features/india/indiaSlice";
import casesReducer from "../features/countries-chart/countriesChartSlice";
import usaReducer from "../features/usa/usaSlice";
import usaChartReducer from "../features/usaCharts/usaChartsSlice";
import canadaChartReducer from "../features/canadaCharts/canadaChartSlice";
export default combineReducers({
  countries: countriesReducer,
  indiaStats: indiaStatsReducer,
  chart: casesReducer,
  usaStats: usaReducer,
  usaChart: usaChartReducer,
  canadaChart: canadaChartReducer,
});
